




























































import { mapActions } from 'vuex';

import { ALForm } from '@/common/component.types';
import { ISystemError } from '@/models/error/error.types';

import mixins from '@/utils/mixins';
import errorForm from '@/mixins/error-form';
import { createDownloadFile, setErrorFromAxiosError } from '@/utils/helpers';
import moment from 'moment';

import ALDialog from '../core/Dialog/ALDialog.vue';
import ErrorAlert from '@/components/common/ErrorAlert.vue';
import DatePicker from '@/components/common/DatePicker.vue';

const baseMixins = mixins(errorForm);

export interface Options extends InstanceType<typeof baseMixins> {
  $refs: {
    form: ALForm;
  };
}

export default baseMixins
  .extend<Options>({
    functional: false
  })
  .extend({
    name: 'EmployeeExportYearFormDialog',
    components: {
      ALDialog,
      ErrorAlert,
      DatePicker
    },

    data() {
      return {
        selectedYear: new Date().getFullYear(),
        dialog: false,
        loading: false,
        isFormValid: false,
        yearRule: [
          (v: number) =>
            /^[12][0-9]{3}$/.test(v.toString()) || 'Year must be valid'
        ],
        error: null as ISystemError | null
      };
    },

    methods: {
      ...mapActions({
        exportEmployeesXLSX: 'employee/exportEmployeesXLSX'
      }),

      resetFormValidation(): void {
        if (this.$refs.form) {
          return this.$refs.form.resetValidation();
        }
      },

      validateForm(): boolean {
        let valid = false;
        if (this.$refs.form) {
          valid = this.$refs.form.validate();
        }
        return valid;
      },

      open(year = new Date().getFullYear()) {
        this.clearErrors();
        this.resetFormValidation();
        this.selectedYear = year;
        this.dialog = true;
      },

      close() {
        this.dialog = false;
      },

      async exportEmployeeList() {
        this.clearErrors();
        const valid = this.validateForm();

        if (valid) {
          this.loading = true;
          this.exportEmployeesXLSX(this.selectedYear)
            .then((data: Blob) => {
              createDownloadFile(
                data,
                `employees-${moment(
                  new Date().setFullYear(this.selectedYear)
                ).format('YYYY')}.xlsx`
              );

              this.close();
            })
            .catch(error => {
              this.error = setErrorFromAxiosError(error);
            })
            .finally(() => {
              this.loading = false;
            });
        }
      },

      clearErrors() {
        this.error = null;
      }
    }
  });
